// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useNavigate } from 'react-router-dom'
import { Modal, UseShowHide } from '@teamnine/pcj-ui-v2'

import { Template as ITemplate } from '@/services/templates'
import { useErrorHelper } from '@/app/shared/hooks/useErrorHelper'
import { useDeleteTemplate } from '@/app/Templates/hooks/useDeleteTemplate'

type DeleteTemplateModalProps = {
  modal: UseShowHide
  template?: ITemplate
}

export default function DeleteTemplateModal({
  modal,
  template,
}: DeleteTemplateModalProps) {
  const navigate = useNavigate()
  const { basicErrorHandler, displayGlobalMessage } = useErrorHelper()
  const { mutateAsync: removeTemplate, isLoading } = useDeleteTemplate()

  const onDeleteTemplate = async () => {
    if (!template?.id) return
    try {
      await removeTemplate(template)
      displayGlobalMessage({
        heading: 'Template successfully deleted.',
        type: 'success',
      })

      modal.hide()
      navigate(`/templates`)
    } catch (err) {
      basicErrorHandler(err)
    }
  }

  return (
    <Modal open={modal.visible} onOpenChange={modal.toggle}>
      <Modal.Display aria-label="Delete Template">
        <Modal.Header title="Delete Template" />
        <Modal.Content>
          Choosing to delete this template will immediately and permanently
          remove it from TCC. Are you sure you want to continue?
        </Modal.Content>
        <Modal.Footer
          footerAction={{
            primaryButton: {
              label: 'Delete',
              type: 'button',
              onClick: onDeleteTemplate,
              loading: isLoading,
            },
            secondaryButton: {
              label: 'Cancel',
              closeModal: true,
            },
          }}
        />
      </Modal.Display>
    </Modal>
  )
}
